export default "__VITE_ASSET__6e1c3b56__"